import React from 'react'

import { ConfirmModal, useModalContext } from '@fourthwall/components'

import { DomainString } from '../DomainString/DomainString'
import * as S from './ConfirmClaimDomainModal.styled'

export type ConfirmClaimDomainModalProps = {
  domain: string
  onConfirm: () => void
}

export const ConfirmClaimDomainModal = ({ domain, onConfirm }: ConfirmClaimDomainModalProps) => {
  const { close } = useModalContext()

  return (
    <ConfirmModal
      title="Claim domain"
      size="medium"
      text={
        <S.Content>
          <div>You're about to claim your free Pro domain:</div>
          <S.DomainName>
            <DomainString domain={domain} />
          </S.DomainName>
          <S.Description>
            Once claimed, this domain will be associated with your Fourthwall account and can be
            used for your site. This action cannot be reversed.
          </S.Description>
        </S.Content>
      }
      confirmLabel="Claim domain"
      onConfirm={onConfirm}
      onCancel={close}
      close={close}
    />
  )
}
